import { connect } from "react-redux";
import actionCreators from "./redux/actionCreators";
import { getMethodList, getInProgress } from "./redux/selectors";
import sourceForm from "./tableMethods";
const mapStateToProps = (state) => ({
    methodList: getMethodList(state),
    inProgress: getInProgress(state)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: async () => {
        await Promise.all([
            dispatch(actionCreators.getMethods()),
            dispatch(actionCreators.getObjects())
        ]);
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(sourceForm);
